"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var constants_1 = require("playable/dist/src/constants");
var lodash_1 = require("lodash");
var time_1 = require("../../../utils/time");
var INTERVAL_TIME = 5000;
var DEFAULT_VALUES_FOR_VIDEO = {
    bitrate: 0,
    width: 0,
    height: 0,
};
var StatisticLogger = /** @class */ (function (_super) {
    tslib_1.__extends(StatisticLogger, _super);
    function StatisticLogger(props) {
        var _this = _super.call(this, props) || this;
        _this.sendBI = function () {
            var _a = _this.props, videoID = _a.videoID, engine = _a.engine, isEmbed = _a.isEmbed, isLive = _a.isLive, channelID = _a.channelID, logFunction = _a.logFunction;
            var debugInfo = engine.getDebugInfo();
            var _b = _this.getDataForBI(debugInfo), url = _b.url, type = _b.type, width = _b.width, height = _b.height, viewportWidth = _b.viewportWidth, viewportHeight = _b.viewportHeight, bitrate = _b.bitrate, deliveryPriority = _b.deliveryPriority, currentTime = _b.currentTime, duration = _b.duration;
            logFunction({
                videoID: videoID,
                channelID: channelID,
                isEmbed: isEmbed,
                isLive: isLive,
                videoUrl: url,
                videoType: type,
                deliveryType: constants_1.MediaStreamDeliveryPriority[deliveryPriority],
                bitrate: bitrate,
                videoWidth: width,
                videoHeight: height,
                viewportWidth: viewportWidth,
                viewportHeight: viewportHeight,
                timeFrame: currentTime,
                duration: (0, time_1.convertSToMS)(duration),
            });
        };
        if (props.videoID && props.shouldSendBI) {
            _this.startIntervalBILogging();
        }
        return _this;
    }
    StatisticLogger.prototype.UNSAFE_componentWillReceiveProps = function (newProps) {
        var shouldSendBI = newProps.shouldSendBI, videoID = newProps.videoID;
        if (shouldSendBI) {
            if (videoID) {
                if (videoID !== this.props.videoID) {
                    this.stopIntervalBILogging();
                    this.startIntervalBILogging();
                }
                else if (this.props.shouldSendBI !== shouldSendBI) {
                    this.startIntervalBILogging();
                }
            }
        }
        else if (this.props.shouldSendBI !== shouldSendBI) {
            this.stopIntervalBILogging();
        }
    };
    StatisticLogger.prototype.componentWillUnmount = function () {
        this.stopIntervalBILogging();
    };
    StatisticLogger.prototype.startIntervalBILogging = function () {
        this._loggingInterval = setInterval(this.sendBI, INTERVAL_TIME);
    };
    StatisticLogger.prototype.getDataForBI = function (info) {
        var url = info.url, currentTime = info.currentTime, type = info.type, deliveryPriority = info.deliveryPriority, _a = info.viewDimensions, viewportWidth = _a.width, viewportHeight = _a.height, duration = info.duration;
        var baseInfo = {
            url: url,
            type: type,
            deliveryPriority: deliveryPriority,
            currentTime: currentTime,
            viewportWidth: viewportWidth,
            viewportHeight: viewportHeight,
            duration: duration,
        };
        var transformedInfo = null;
        switch (type) {
            case constants_1.MediaStreamType.DASH: {
                transformedInfo = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, baseInfo), DEFAULT_VALUES_FOR_VIDEO), this.getDashInfo(info));
                break;
            }
            case constants_1.MediaStreamType.HLS: {
                transformedInfo = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, baseInfo), DEFAULT_VALUES_FOR_VIDEO), this.getHlsInfo(info));
                break;
            }
            default: {
                transformedInfo = tslib_1.__assign(tslib_1.__assign({}, baseInfo), DEFAULT_VALUES_FOR_VIDEO);
                break;
            }
        }
        return transformedInfo;
    };
    StatisticLogger.prototype.getStreamInfo = function (info) {
        return (0, lodash_1.pick)(info.currentBitrate, ['width', 'height', 'bitrate']);
    };
    StatisticLogger.prototype.getDashInfo = function (info) {
        return this.getStreamInfo(info);
    };
    StatisticLogger.prototype.getHlsInfo = function (info) {
        var currentBitrate = info.currentBitrate;
        if (currentBitrate) {
            return this.getStreamInfo(info);
        }
        return tslib_1.__assign({}, DEFAULT_VALUES_FOR_VIDEO);
    };
    StatisticLogger.prototype.stopIntervalBILogging = function () {
        clearInterval(this._loggingInterval);
    };
    StatisticLogger.prototype.render = function () {
        return null;
    };
    StatisticLogger.dependencies = ['engine'];
    StatisticLogger.propTypes = {
        engine: prop_types_1.default.object,
        videoID: prop_types_1.default.string.isRequired,
        channelID: prop_types_1.default.string.isRequired,
        logFunction: prop_types_1.default.func.isRequired,
        shouldSendBI: prop_types_1.default.bool,
        isEmbed: prop_types_1.default.bool,
        isLive: prop_types_1.default.bool,
    };
    StatisticLogger.defaultProps = {
        isEmbed: false,
        duration: null,
    };
    return StatisticLogger;
}(react_1.default.Component));
exports.default = StatisticLogger;
//# sourceMappingURL=statistic-logger.js.map